import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { UserRole, STORAGE_KEYS } from './constants.ts';
import './App.css';

interface AppProps {
  children: React.ReactNode;
}

function App({ children }: AppProps) {
  console.log('[App] Component rendering');
  console.log('[App] children:', children);
  console.log('[App] children type:', typeof children);
  
  const navigate = useNavigate();
  const location = useLocation();
  console.log('[App] Current location:', location.pathname);
  
  const token = localStorage.getItem(STORAGE_KEYS.JWT_TOKEN);
  const username = localStorage.getItem(STORAGE_KEYS.USERNAME) || 'Guest';
  const isLoggedIn = !!token;
  console.log('[App] Username:', username);
  console.log('[App] Is logged in:', isLoggedIn);

  const handleLogout = () => {
    console.log('[App] Logout clicked');
    localStorage.removeItem(STORAGE_KEYS.USER_ROLE);
    localStorage.removeItem(STORAGE_KEYS.USERNAME);
    localStorage.removeItem(STORAGE_KEYS.JWT_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER_DATA);
    navigate('/login');
  };

  const handleLogin = () => {
    console.log('[App] Login clicked');
    navigate('/login');
  };

  console.log('[App] About to render, children:', !!children);

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-top">
          <h1>🎲 Online Board Games</h1>
          <div className="user-info">
            <span>Welcome, {username}!</span>
            {isLoggedIn ? (
              <button onClick={handleLogout} className="logout-btn">Logout</button>
            ) : (
              <button onClick={handleLogin} className="logout-btn">Login</button>
            )}
          </div>
        </div>
      </header>
      
      <main>
        {children}
      </main>
    </div>
  );
}

export default App;
